import moment from 'moment';
import React from 'react'

export const TableRow = (props) => {
  const { value, user, account, createdAt, methodId, thirdPartyTransId, referenceNumber, fee, total, handleFee } = props;

  const bankLogo = account && account.bank && account.bank.logo;

  return (
    <tr>
      <td>
        {(user && user.name) || ""}<br />
        <span><strong className={`text-primary`}>{(user && user.phone && user.phone.replace('+84', '0')) || ""}</strong></span>
      </td>

      {methodId === 'BANKING' ? (
        <td>
          {bankLogo ? (
            <img alt='' src={bankLogo} className="img-thumbnail" width={100} height={30} />
          ) : (
            <span>BANKING</span>
          )}
        </td>
      ) : (
        <td>
          {methodId}
        </td>
      )}
      <td className="fw-900 text-success text-right">{new Intl.NumberFormat('vn-VI', {}).format(value) || ""}</td>
      <td className="fw-900 text-success text-right">{new Intl.NumberFormat('vn-VI', {}).format(fee) || ""}</td>
      <td className="fw-900 text-success text-right">{new Intl.NumberFormat('vn-VI', {}).format(handleFee) || ""}</td>
      <td className="fw-900 text-success text-right">{new Intl.NumberFormat('vn-VI', {}).format(total) || ""}</td>
      <td>{thirdPartyTransId || referenceNumber || ''}</td>
      <td className="text-center">{moment(createdAt || '').format('DD/MM/YYYY HH:mm:ss')}</td>
    </tr>
  );
};
